<template>
	<div>
		<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
			<el-form-item label="姓名">
				<el-input clearable v-model="searchCondition.realname" placeholder="请输入姓名"></el-input>
			</el-form-item>
			<el-form-item label="证件号码">
				<el-input clearable v-model="searchCondition.id_number" placeholder="请输入证件号码"></el-input>
			</el-form-item>
			<el-form-item label="交付状态">
				<el-select style="width: 110px;" clearable v-model="searchCondition.examine_status" placeholder="交付状态">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="时间">
				<DatePicker :value="dateRangeValue" @dataSearch="dataSearch" />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="searchButton">查询</el-button>
				<el-button style="margin-left: 24px" :loading="downloadLoading" type="primary" icon="el-icon-document" @click="handleDownload">导出</el-button>
				<el-button type="primary" @click="examineAll">一键审核</el-button>
			</el-form-item>
		</el-form>
		<div style="margin-bottom: 20px" v-if="$route.meta.hideBack">
			<ScreeCompany ref="screeCompanyRef" :allowField="allowField" @ScreeCompany="ScreeCompany" />
		</div>
		<div style="margin: 0 20px">
			<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#fbfbfb' }" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" :selectable="event_selectable"></el-table-column>
				<el-table-column v-for="item in tableColumns" :key="item.prop" :prop="item.prop" :label="item.label" :align="item.align || 'center'"></el-table-column>
				<el-table-column prop="examine_status" label="状态" align="center">
					<template slot-scope="scope">
						{{ scope.row.q_deliver_status }}
					</template>
				</el-table-column>
				<el-table-column prop="examine_status" label="交付时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.created_at }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.examine_status == 0" size="mini" type="primary" @click="taskClick(scope.row, 'examine')">审核</el-button>
						<el-button size="mini" @click="taskClick(scope.row, 'edit')">编辑</el-button>
						<el-button v-if="scope.row.examine_status === 3" @click="showBohui(scope.row)" size="mini" type="warning">驳回意见</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<el-dialog title="驳回意见" :visible.sync="bohuiDialog.show" width="30%" @close="closeBohui">
			<div>
				{{ bohuiDialog.data.examine_message }}
			</div>
			<div style="text-align: center; margin-top: 20px">
				<span slot="footer" class="dialog-footer">
					<el-button @click="closeBohui" size="mini" type="primary">确 认</el-button>
				</span>
			</div>
		</el-dialog>

		<el-dialog title="审核" :visible.sync="shenheDialog.show" width="50%" @close="userClose">
			<div class="shenhe-content-tip">
				tip:请认真核对任务说明及上传的相关图片资料，全面核查业务相关信息；税务部门将对业务真实性开展不定期抽查，确保业务开展合规有序。
			</div>
			<el-radio-group v-model="shenheDialog.data.examine_status">
				<el-radio :label="1">审核通过</el-radio>
				<el-radio :label="2">审核拒绝</el-radio>
			</el-radio-group>
			<div v-if="shenheDialog.data.examine_status == 2" style="margin-top: 30px">
				<el-form label-width="90px" ref="userRef">
					<el-form-item prop="textarea">
						<el-input type="textarea" placeholder="请输入原因" v-model="shenheDialog.data.examine_message" maxlength="100" show-word-limit :rows="5"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeShenhe" style="margin-right: 24px;">取 消</el-button>
				<el-button type="primary" @click="confirmShenhe">确 定</el-button>
			</span>
		</el-dialog>

		<el-pagination
			style="float: right"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page.sync="pagege.current_page"
			:page-sizes="[10, 20, 50, 100]"
			:page-size="pagege.page_size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="pagege.total"
		></el-pagination>
	</div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import ScreeCompany from "@/components/ScreeCompany.vue";

export default {
	name: "PrivatePersonnelListContent",
	components: {
		DatePicker,
		ScreeCompany,
	},
	watch: {
		"$route.matched": function(n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		},
	},
	data() {
		return {
			query: {},
			shenheData: [],
			options_text: ["待审核", "", "交付通过", "交付未通过"],
			options: [
				{
					value: "0",
					label: "待审核",
				},
				{
					value: "2",
					label: "交付通过",
				},
				{
					value: "3",
					label: "交付未通过",
				},
			],
			allowField: ["companyId", "settlementId"],
			tableColumns: [
				{
					prop: "title",
					label: "任务名称",
				},
				{
					prop: "company_name",
					label: "公司名称",
				},
				{
					prop: "channel_name",
					label: "税源地名称",
				},
				{
					prop: "realname",
					label: "姓名",
				},
				{
					prop: "id_number",
					label: "证件号码",
				},
			],
			searchCondition: {},
			dateRangeValue: [],
			pagege: {},
			currentPage2: "",
			id: "",
			Status: "",
			mission_content: "",
			tableData: [],
			selecTabletData: [],
			ispage: 1,
			num: 10,
			downloadLoading: false,
			bohuiDialog: {
				show: false,
				data: {},
			},
			shenheDialog: {
				show: false,
				data: {
					ids: [],
					examine_status: 1,
					examine_message: "",
				},
			},
		};
	},
	created() {
		this.query = this.$route.query;
		this.restoreRouteState();
		this.init();
	},
	methods: {
		restoreRouteState() {
			const {
				realname,
				id_number,
				examine_status,
				company_id,
				channel_account,
				current_page,
				page_size,
				start_time,
				end_time,
			} = this.$route.query;
			this.searchCondition = {
				realname: realname || "",
				id_number: id_number || "",
				examine_status: examine_status || "",
			};
			if (company_id) {
				this.searchCondition.company_id = company_id;
			}
			if (channel_account) {
				this.searchCondition.channel_account = channel_account;
			}
			if (start_time && end_time) {
				this.searchCondition.time = {
					start_time,
					end_time,
				};
				this.dateRangeValue = [start_time, end_time];
			} else {
				this.dateRangeValue = [];
			}
			this.ispage = Number(current_page) || 1;
			this.num = Number(page_size) || 10;
			this.$nextTick(() => {
				if (this.$refs.screeCompanyRef) {
					this.$refs.screeCompanyRef.companyId = company_id || "";
					this.$refs.screeCompanyRef.settlementId = channel_account || "";
				}
			});
		},
		syncRouteQuery() {
			const query = {
				id: this.$route.query.id,
				realname: this.searchCondition.realname || undefined,
				id_number: this.searchCondition.id_number || undefined,
				examine_status: this.searchCondition.examine_status || undefined,
				company_id: this.searchCondition.company_id || undefined,
				channel_account: this.searchCondition.channel_account || undefined,
				current_page: this.ispage !== 1 ? String(this.ispage) : undefined,
				page_size: this.num !== 10 ? String(this.num) : undefined,
				start_time: this.searchCondition.time?.start_time || undefined,
				end_time: this.searchCondition.time?.end_time || undefined,
			};
			this.$router.replace({
				path: this.$route.path,
				query,
			});
		},
		closeShenhe() {
			this.shenheDialog = {
				show: false,
				data: {},
			};
		},
		async confirmShenhe() {
			let params = {
				ids: this.shenheDialog.data.ids,
				examine_status: this.shenheDialog.data.examine_status,
				examine_message: this.shenheDialog.data.examine_message,
			};
			await this.$api.post_deliver_privatejoinAllExamine(params);
			this.$message.success("审核成功");
			this.closeShenhe();
			this.init();
		},
		examineAll() {
			if (this.selecTabletData.length === 0) {
				this.$message.warning("您当前未进行勾选，请勾选后再进行操作");
				return;
			}
			this.shenheDialog.data.ids = this.selecTabletData.map((item) => item.id);
			this.shenheDialog.show = true;
		},
		handleSelectionChange(data) {
			this.selecTabletData = data;
			console.log(this.selecTabletData);
		},
		event_selectable(row) {
			if (row.examine_status == "0") {
				return true;
			}
		},
		closeBohui() {
			this.bohuiDialog = {
				show: false,
				data: {},
			};
		},
		showBohui(row) {
			this.bohuiDialog = {
				show: true,
				data: row,
			};
			console.log(this.bohuiDialog, "bohuiDialog");
		},
		async handleDownload() {
			this.downloadLoading = true;
			try {
				let list = await this.init("export");
				console.log(list, "list");
				if (!list || list.length === 0) {
					this.$message.warning("暂无数据");
					return;
				}
				const excel = await import("@/excel/Export2Excel");
				let sHeader = [
					"任务名称",
					"公司名称",
					"税源地名称",
					"姓名",
					"证件号码",
					"状态",
					"审核时间",
					"审核意见",
					"交付内容",
					"交付图片",
				];
				const data = this.formatJson(list);
				console.log(data, "data");
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `${time}`;
				excel.export_json_to_excel({
					header: sHeader,
					data,
					filename: filename,
					autoWidth: true,
					bookType: "xlsx",
				});
			} catch (error) {
				console.error(error);
				this.$message.error("导出失败");
			} finally {
				this.downloadLoading = false;
			}
		},
		formatJson(jsonData) {
			return jsonData.map((v) => {
				console.log(v, "v");
				let {
					title,
					company_name,
					channel_name,
					realname,
					id_number,
					q_deliver_status,
					deliver_examine_at,
					examine_message,
					deliver_content,
					deliver_images,
				} = v;
				let arr = [
					title,
					company_name,
					channel_name,
					realname,
					id_number,
					q_deliver_status,
					deliver_examine_at,
					examine_message,
					deliver_content,
					deliver_images,
				];
				return arr;
			});
		},
		searchButton() {
			this.ispage = 1;
			this.syncRouteQuery();
			this.init();
		},
		dataSearch(value) {
			console.log(value);
			if (value.length) {
				this.searchCondition.time = {};
				this.searchCondition.time.start_time = value[0];
				this.searchCondition.time.end_time = value[1];
				this.dateRangeValue = value;
			} else {
				delete this.searchCondition.time;
				this.dateRangeValue = [];
			}
			this.syncRouteQuery();
		},
		ScreeCompany(v, name) {
			if (name == "company") {
				if (v) {
					this.searchCondition.company_id = v;
				} else {
					delete this.searchCondition.company_id;
				}
			}
			if (name == "settlement") {
				if (v) {
					this.searchCondition.channel_account = v;
				} else {
					delete this.searchCondition.channel_account;
				}
			}
			this.syncRouteQuery();
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.num = val;
			this.ispage = 1;
			this.syncRouteQuery();
			this.init();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.ispage = val;
			this.syncRouteQuery();
			this.init();
		},
		taskClick(row, type) {
			this.$router.push({
				path: "/deliveryPrivatePersonnelDetail",
				query: { id: row.id, type },
			});
		},
		async init(type) {
			let objects = {
				current_page: this.ispage,
				page_size: this.num,
				realname: this.searchCondition.realname,
				id_number: this.searchCondition.id_number,
				company_id: this.searchCondition.company_id,
				channel_account: this.searchCondition.channel_account,
				examine_status: this.searchCondition.examine_status,
				time: this.searchCondition.time,
				mission_id: this.query.id,
			};
			if (type === "export") {
				objects.page_size = 9999999;
			}
			let res = {};
			res = await this.$api.post_deliver_privatejoinList(objects);
			let { data, pages } = res;
			let tableData = data.map((item) => {
				return {
					...item,
					q_deliver_status: this.options_text[item.examine_status],
					company_name: item?.company?.name,
					channel_name: item?.settlement?.channel_name,
				};
			});
			if (type === "export") {
				return tableData;
			}
			console.log(pages, res);
			this.tableData = tableData;
			this.pagege = pages;
		},
		taskseeClick(row) {
			this.mission_content = row.mission_content || row.job_remark;
			console.log(row);
			this.taskseedialogVisible = true;
		},
		userClose() {},
		examineClick(row) {
			this.id = row.id;
			this.radio = 1;
			this.userList.textarea = "";
			this.examinedialogVisible = true;
		},
		async userInfo() {
			let obj = {
				examine_status: this.radio,
				examine_reason: this.userList.textarea,
			};
			console.log(obj, "obj");
			if (obj.examine_status == 2 && obj.examine_reason == "") {
				this.$message.error("请填写拒绝理由");
			} else {
				let Status = await this.$api.postDaily_taskExamine(this.id, obj);
				this.$nextTick(() => {
					if (Status) {
						this.$message.success("审核成功!");
						this.init();
						this.examinedialogVisible = false;
					}
				});
			}
		},
	},
};
</script>

<style scoped lang="scss">
.table-sys-box {
	margin-bottom: 20px;
}
.shenhe-content-tip {
	margin-bottom: 20px;
	font-size: 12px;
	color: red;
}
::v-deep .el-table-column--selection .cell {
	padding-left: 15px;
}
</style>
